// src/components/ui/Field.tsx — labelled input or textarea.
import type { CSSProperties } from "react";
import { C, F } from "../../theme";

export interface FieldProps {
  label?: string;
  value: string | null | undefined;
  onChange: (next: string) => void;
  type?: string;
  ph?: string;
  rows?: number;
  max?: number;
  style?: CSSProperties;
  disabled?: boolean;
}

export const Field = ({
  label,
  value,
  onChange,
  type = "text",
  ph = "",
  rows,
  max,
  style,
  disabled,
}: FieldProps) => {
  const inputStyle: CSSProperties = {
    width: "100%",
    padding: "12px 14px",
    borderRadius: 12,
    border: `1px solid ${C.hairline}`,
    background: C.card,
    fontFamily: type === "date" ? F.mono : F.body,
    fontSize: 15,
    fontWeight: 600,
    color: C.ink,
    outline: "none",
    boxSizing: "border-box",
    opacity: disabled ? 0.6 : 1,
  };
  const textareaStyle: CSSProperties = {
    ...inputStyle,
    resize: "vertical",
    lineHeight: 1.5,
    fontFamily: F.body,
  };
  return (
    <div style={{ marginBottom: 14, ...style }}>
      {label && (
        <label
          style={{
            display: "block",
            fontFamily: F.serif,
            fontStyle: "italic",
            fontSize: 13,
            fontWeight: 600,
            color: C.brassDk,
            marginBottom: 6,
            letterSpacing: 0.2,
          }}
        >
          {label}
        </label>
      )}
      {rows ? (
        <textarea
          value={value ?? ""}
          onChange={(e) => onChange(max ? e.target.value.slice(0, max) : e.target.value)}
          rows={rows}
          placeholder={ph}
          disabled={disabled}
          style={textareaStyle}
        />
      ) : (
        <input
          type={type}
          value={value ?? ""}
          onChange={(e) => onChange(max ? e.target.value.slice(0, max) : e.target.value)}
          placeholder={ph}
          disabled={disabled}
          style={inputStyle}
        />
      )}
    </div>
  );
};
